export class UberFilterConfig {
    type?: string; //future use to support more types than multicheckbox
    // disable?: boolean=false;
    disableEmitter?: any;
    affects?: string[]; // Support for hierarchical filtering 
    filterConfig: any;

    constructor({ type='checkbox', disableEmitter = null, affects = [], filterConfig }) {
        this.type = type;
        this.disableEmitter = disableEmitter;
        this.affects = affects;
        this.filterConfig = filterConfig;
    }
}







// WEBPACK FOOTER //
// ./src/app/shared/components/uber-filter/uber-filter-config.ts